import { Injectable, isDevMode } from '@angular/core';
import { ClicktermClient } from '@clickterm/widget';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClicktermService {
  private clicktermInitialized = false;

  initialize(): boolean {
    if (this.clicktermInitialized) {
      return true;
    }

    if (typeof window === 'undefined') {
      console.error('Window is not available. Cannot get clickterm SDK.');
      return false;
    }

    const hostname = window.location.hostname ?? '';
    const baseUrl = isDevMode() || hostname.includes('app.dev.telqtele.com') ? 'https://api.dev.clickterm.com' : undefined;
    ClicktermClient.initialize(environment.clicktermAppId, baseUrl);
    this.clicktermInitialized = true;

    return true;
  }
}
